(() => {
  const COPIES = 5;
  const MIDDLE = Math.floor(COPIES / 2); // 2 — arranca en la copia del medio

  const carousels = document.querySelectorAll('[data-photo-carousel]');

  carousels.forEach((carousel) => {
    const track = carousel.querySelector('[data-photo-carousel-track]');
    if (!track) return;

    let setWidth = 0;

    // El ancho de cada item es fijo por CSS (aspect-ratio + width fija),
    // no depende de que la <img> haya cargado — medir de inmediato, sin
    // esperar a los 'load' de imagenes. Esperar a TODAS (incluidas las
    // copias-buffer, que son lazy y pueden cargar mucho despues, casi
    // al scrollear hasta ellas) causaba un re-medido tardio a mitad de
    // interaccion que reseteaba el scroll al principio de golpe.
    const measure = () => {
      setWidth = track.scrollWidth / COPIES;
      track.scrollLeft = setWidth * MIDDLE;
    };

    measure();
    window.addEventListener('resize', measure);

    // Salta al set contiguo con margen (medio ancho de copia) antes de
    // llegar al limite real de scroll — si esperamos a scrollLeft 0/max,
    // el navegador puede disparar su propio rebote elastico justo antes
    // de que el salto se aplique, y eso se ve como si el carrusel
    // "tirase" para el lado contrario.
    //
    // Se comprueba con requestAnimationFrame, NO con el evento 'scroll':
    // en desktop el arrastre es JS puro (cada pointermove fija scrollLeft
    // a mano, y eso dispara 'scroll' al instante), pero en movil el
    // scroll es nativo del navegador, y con inercia Safari/iOS no
    // dispara 'scroll' con la misma frecuencia durante el gesto — a
    // veces solo al terminar. Un swipe rapido podia llegar al final real
    // del track (ya no hay mas copias) antes de que 'scroll' diera pie a
    // corregir, y el carrusel se quedaba parado en el borde en vez de
    // dar la vuelta. rAF comprueba cada frame sin depender de ese evento,
    // asi que funciona igual sea cual sea el motor de scroll.
    const checkLoop = () => {
      if (setWidth) {
        const min = setWidth * 0.5;
        const max = setWidth * (COPIES - 1.5);
        if (track.scrollLeft < min) {
          track.scrollLeft += setWidth;
        } else if (track.scrollLeft > max) {
          track.scrollLeft -= setWidth;
        }
      }
      requestAnimationFrame(checkLoop);
    };
    requestAnimationFrame(checkLoop);

    // Trackpad de dos dedos hacia los lados (o shift+rueda) mueve el
    // carrusel — pero no la rueda vertical normal, si no, se secuestra
    // el scroll de la pagina en cuanto el raton pasa por encima.
    track.addEventListener(
      'wheel',
      (e) => {
        if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
        e.preventDefault();
        track.scrollLeft += e.deltaX;
      },
      { passive: false }
    );

    // Arrastrar con raton en desktop — el touch de movil ya arrastra de
    // forma nativa via overflow-x:auto, no tocar ese camino.
    let isDragging = false;
    let startX = 0;
    let startScroll = 0;

    track.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse') return;
      isDragging = true;
      startX = e.clientX;
      startScroll = track.scrollLeft;
      track.classList.add('is-dragging');
      track.setPointerCapture(e.pointerId);
    });

    track.addEventListener('pointermove', (e) => {
      if (!isDragging) return;
      track.scrollLeft = startScroll - (e.clientX - startX);
    });

    const endDrag = () => {
      isDragging = false;
      track.classList.remove('is-dragging');
    };

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
  });
})();
